export const capitalise = function () {
  let string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (force) {
    string = string.toLowerCase();
  }
  return string.charAt(0).toUpperCase() + string.substring(1);
};
export const slugify = function () {
  let string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  let separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "-";
  return string.toString().normalize("NFD") // split an accented letter in the base letter and the acent
  .replace(/[\u0300-\u036f]/g, "") // remove all previously split accents
  .toLowerCase().trim().replace(/[^a-z0-9 ]/g, "") // remove all chars not letters, numbers and spaces (to be replaced)
  .replace(/\s+/g, separator);
};